export { default } from '@/pages/store/checkout'
